import type { ReactNode } from "react";
import { Cluster, HintMark, LabelWithHint } from "@salesapp/ui";

/** KPI / card kicker with an info mark. */
export function TipKicker({ label, tip }: { label: string; tip: string }) {
  return (
    <p className="admin-kicker">
      <LabelWithHint label={label} tooltip={tip} />
    </p>
  );
}

/** Section heading with an info mark beside the title. */
export function TipHeading({
  as: Tag = "h3",
  label,
  tip,
  children,
}: {
  as?: "h2" | "h3" | "h4";
  label: string;
  tip: string;
  children?: ReactNode;
}) {
  return (
    <Cluster gap={2} align="center">
      <Tag>{label}</Tag>
      <HintMark text={tip} label={`About ${label}`} />
      {children}
    </Cluster>
  );
}
